import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';

export const FieldSkeleton: FC<{
  children?: ReactNode;
  className?: string;
}> = ({ className, children }) => <div className={classNames(className, 'form-control')}>{children}</div>;

export const LoadingFieldSkeleton: FC<{ className?: string }> = ({ className }) => (
  <FieldSkeleton className={classNames('bg-lvl2', className)}>
    <Skeleton width="100%" />
  </FieldSkeleton>
);
